import {Typography, useMediaQuery, Box, CircularProgress} from '@mui/material';

const backgroundStyles = {
  color: '#71d7d9',
  position: 'absolute',
  top: 0,
  left: 0,
};

const containerStyles = {
  position: 'relative',
  width: '90px',
  height: '65px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const progressStyles = {
  color: '#ffffff',
  position: 'absolute',
  top: 0,
  left: 0,
};

const textStyles = {
  ...progressStyles,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '90px',
  fontWeight: 'bold',
  pointerEvents: 'none',
};

/**
 * Component representing a streak history display.
 *
 * @component
 * @param {Object} props - The component properties.
 * @param {number} props.currentStreak - The current streak value.
 * @param {number} props.maxStreak - The maximum streak value.
 * @returns {JSX.Element} The StreakHistory component.
 */
export const StreakHistory = ({currentStreak, maxStreak}) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={1}>
      <Box alignItems="center" justifyContent="center" sx={{mb: 0}}>
        <div style={containerStyles}>
          <CircularProgress variant="determinate" value={100} size={90} thickness={4} sx={backgroundStyles} />
          <CircularProgress variant="determinate" value={currentStreak} size={90} thickness={4} sx={progressStyles} />
          <Typography variant="subtitle2" sx={textStyles}>
            {`${currentStreak} days`}
          </Typography>
        </div>
      </Box>
      <Typography
        variant="body2"
        color="white"
        sx={{
          fontSize: isSmallScreen ? '13px' : '15px',
          mt: 0,
          textAlign: 'center',
        }}
      >
        Streak to beat: <span style={{fontWeight: 700}}>{maxStreak} days</span>
      </Typography>
    </Box>
  );
};
